
import React from 'react';
import {connect} from 'react-redux';
import { Formik, Field } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import SocialSecurity from './Scenario/SocialSecurity';
import ApplicationHelpers from '../../ApplicationHelpers';

// const initialValues = {
//     client:{},
//     spouse:{}
// };
class Step3 extends React.Component {
    constructor(props) {
        super(props);
        this.state ={cola:0};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCOLAChange = this.handleCOLAChange.bind(this);
    }
    handleCOLAChange(cola){
        cola = parseFloat(cola)
        // console.log('new cola',cola)
        this.setState({cola:cola});
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    let finalValues = {
        socialSecurityBenefits: [{
            owner:'client',
            monthlyBenefit: values.client.amount,
            startAge: values.client.age,
            // cola: values.client.cola,
            forLife:true,
            endAge:0,
            clientYear: (this.props.scenario.employment.isRetired === 'false' ? this.props.scenario.employment.projectedRetirementDate.yar:'')
        }]
    };
    if(this.props.client.isMarried === 'true'){
        finalValues.socialSecurityBenefits.push({
            owner:'spouse',
            monthlyBenefit: values.spouse.amount,
            startAge: values.spouse.age,
            // cola:values.spouse.cola,
            forLife:true,
            endAge:0,
            spouseYear: (this.props.scenario.spouse.employment.isRetired === 'false' ? this.props.scenario.spouse.employment.projectedRetirementDate.yar:'')
        });
    }
    this.props.upliftState(finalValues,'scenario');
    this.props.nextStep();
    return;
  }
   
  render() {
    let form = this.props.form;
    let ages = {client:60,spouse:60};
    ages.client =  ApplicationHelpers.ageAt(new Date(form.client.birthdate),new Date(),true);
    if(form.client && form.client.isMarried === 'true'){
        ages.spouse =  ApplicationHelpers.ageAt(new Date(form.client.spouse.birthdate),new Date(),true);
    }
        let ageLimit = 60;
        if(ageLimit < ages.client){
            ageLimit = ages.client;
        }
    let baseSchema = {
        client: yup.object().shape({
                age: yup.number().positive().integer('Age must be an integer').min(ageLimit,'Age should be equal or greater than '+ageLimit).max(100,'Age should not be more than 100'),
                amount: yup.number(),
                // cola: yup.number()
        })
      };
     if(this.props && this.props.client && this.props.client.isMarried === 'true'){
        let spouseAgeLimit = 60;
        if(spouseAgeLimit < ages.spouse){
            spouseAgeLimit = ages.spouse;
        }
         baseSchema.spouse = yup.object().shape({
                age: yup.number().positive().integer('Age must be an integer').min(spouseAgeLimit,'Age should be equal or greater than '+spouseAgeLimit).max(100,'Age should not be more than 100'),
                amount: yup.number(),
                // cola:yup.number()
        })
     }
     const schema = yup.object().shape(baseSchema);
    return(

                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                        setFieldTouched,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                            <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>3.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                        {this.props.getStepHeader(3) } 
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats type="edit" step={3} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                                <Card>
                                    <Card.Header>{this.props.client.firstName}'s Information</Card.Header>
                                    <Card.Body>
                                        <Field
                                            component={SocialSecurity} 
                                            handleSubmit={handleSubmit} 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            values={values}
                                            errors={errors }
                                            touched={touched}
                                            isSubmitting={isSubmitting} 
                                            form={this.props.form}
                                            colachange={this.handleCOLAChange}
                                            cola={this.state.cola}
                                            type="client" />
                                    </Card.Body>
                                </Card>
                                {this.props.client.isMarried === 'true' &&
                                <React.Fragment>
                                    <br />                         
                                <Card>
                                    <Card.Header>{this.props.client.spouse.firstName}'s Information</Card.Header>
                                    <Card.Body>
                                        {this.props.client.isMarried === 'true' &&
                                            <Field
                                            component={SocialSecurity} 
                                            handleSubmit={handleSubmit} 
                                            handleChange={handleChange} 
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            values={values}
                                            errors={errors }
                                            touched={touched}
                                            isSubmitting={isSubmitting} 
                                            form={this.props.form}
                                            colachange={this.handleCOLAChange}
                                            cola={this.state.cola}
                                            type="spouse" />
                                        }
                                    </Card.Body>
                                </Card>
                            </React.Fragment>
                            }
                            <Form.Row>
                            <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step3Continue">
                                <Col md={"12"} sm={"12"}>
                                    <br />
                                    <Stats type='continue' step={3} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                        </Card.Body>
                        </Collapse>
                        </Card>
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        let css={},sss={};
        if(Array.isArray(scenario.socialSecurityBenefits)){
            let socialSecurityBenefits = scenario.socialSecurityBenefits;
            socialSecurityBenefits.map(ss =>{
                if(ss.owner === 'client'){
                    css=ss;
                }
                else if(ss.owner === 'spouse'){
                    sss = ss;
                }
                return true;
            });
        }
        return {
            form,
            isMarried:client.isMarried,
            client:{
                ...client,
                isMarried:client.isMarried,
                age: css.startAge,
                amount: css.monthlyBenefit
            },
            spouse: {
                ...client.spouse,
                firstName: client.spouse.firstName,
                age: sss.startAge,
                amount: sss.monthlyBenefit
            },
            scenario,
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
  )(Step3)